export type TError = {
  code: string;
  detail: string;
  attr: string;
};

export interface TokenRequest {
  email: string;
  password: string;
}

export interface RegistrationRequest {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  personal_info?: string;
  nickname?: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ConfirmPassword {
  new_password: string;
  confirm_new_password: string;
}

export interface ConfirmPasswordRequest extends ConfirmPassword {
  uidb64: string;
  token: string;
}

export interface EmailVerifyRequest {
  uidb64: string;
  token: string;
}

export interface EmailVerifyResponse {
  message: string;
}

export interface ChangePasswordRequest extends ConfirmPassword {
  old_password: string;
}

export interface TokenResponse {
  access: string;
  refresh: string;
}

export interface LogoutResponse {
  access: string;
}

export interface RegistrationResponse {
  email: string;
  first_name: string;
  last_name: string;
  nickname: string;
  personal_info: string;
}

export interface ProfileAvatar {
  first_name: string;
  last_name: string;
}

interface UserGroup {
  id: number;
  name: string;
  display_name: string;
}

export interface ProfileResponse {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  personal_info: string;
  user_groups: UserGroup[];
}

export interface UpdateProfileRequest {
  first_name?: string;
  last_name?: string;
  email?: string;
  personal_info?: string;
}

export enum EReduxQueryTags {
  User = 'User',
  Challenge = 'Challenge',
  Debate = 'Debate',
  CurrentDebate = 'CurrentDebate',
  CurrentChallenge = 'CurrentChallenge',
}

export type TQueryError = {
  status: string | number;
  data: string | any;
};
